// extracted by mini-css-extract-plugin
export default {"timer":"a1-z","loaded":"b1-z"};